import React from 'react'

interface Props {
  className?: string
}

function Page({className = ''}: Props) {
  return (
    <div
      className={`mx-auto grid md:grid-cols-4 md:gap-[74px] ${className}`}
    >
      <svg
        width="120"
        height="60"
        viewBox="0 0 120 60"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="w-[120px] h-[60px]"
        preserveAspectRatio="none"
      >
        <path
          d="M43.092 39.2731C47.902 39.2731 51.819 35.5701 51.819 30.5451C51.819 25.4851 47.901 21.8181 43.092 21.8181C38.283 21.8181 34.365 25.4851 34.365 30.5451C34.365 35.5701 38.283 39.2731 43.092 39.2731ZM43.092 25.2561C45.728 25.2561 47.999 27.4051 47.999 30.5451C47.999 33.6491 45.727 35.8331 43.092 35.8331C40.456 35.8331 38.185 33.6531 38.185 30.5451C38.185 27.4051 40.455 25.2561 43.092 25.2561V25.2561Z"
          fill="#EA4335"
        />
        <path
          d="M62.727 39.2731C67.537 39.2731 71.455 35.5701 71.455 30.5451C71.455 25.4851 67.536 21.8181 62.727 21.8181C57.919 21.8181 54 25.4891 54 30.5451C54 35.5701 57.919 39.2731 62.727 39.2731V39.2731ZM62.727 25.2561C65.363 25.2561 67.634 27.4051 67.634 30.5451C67.634 33.6491 65.363 35.8331 62.727 35.8331C60.091 35.8331 57.82 33.6531 57.82 30.5451C57.82 27.4051 60.09 25.2561 62.727 25.2561V25.2561Z"
          fill="#FBBC05"
        />
        <path
          d="M90 38.5961V22.3681H86.203V23.8401H86.063C85.165 22.7761 83.44 21.8181 81.269 21.8181C76.716 21.8181 72.546 25.7881 72.546 30.8921C72.546 35.9591 76.716 39.8961 81.269 39.8961C83.444 39.8961 85.169 38.9381 86.063 37.8421H86.203V39.1421C86.203 42.6031 84.343 44.4421 81.343 44.4421C78.896 44.4421 77.377 42.7051 76.757 41.2331L73.277 42.6731C74.277 45.0681 76.933 48.0001 81.346 48.0001C86.035 48.0001 90 45.2731 90 38.5961ZM81.626 25.3811C84.348 25.3811 86.486 27.7081 86.486 30.8911C86.486 34.0431 84.348 36.3381 81.626 36.3381C78.868 36.3381 76.556 34.0431 76.556 30.8921C76.556 27.7081 78.868 25.3811 81.626 25.3811V25.3811Z"
          fill="#4285F4"
        />
        <path
          d="M95.455 13.0901V39.2721H92.182V13.0911H95.455V13.0901Z"
          fill="#34A853"
        />
        <path
          d="M113.833 35.4051L110.809 33.4221C109.801 34.8781 108.425 35.8381 106.441 35.8381C104.461 35.8381 103.049 34.9441 102.141 33.1931L114.001 28.3621L113.597 27.3701C112.861 25.4221 110.609 21.8181 106.005 21.8181C101.433 21.8181 97.637 25.3551 97.637 30.5451C97.637 35.4401 101.401 39.2731 106.441 39.2731C110.505 39.2731 112.857 36.8251 113.833 35.4051V35.4051ZM109.43 27.0441L101.502 30.2821C101.402 26.9141 104.158 25.1941 106.138 25.1941C107.682 25.1941 108.994 25.9541 109.43 27.0441Z"
          fill="#EA4335"
        />
        <path
          d="M20.195 28.21V24.484H33.082C33.208 25.134 33.272 25.902 33.272 26.734C33.272 29.529 32.488 32.985 29.961 35.448C27.502 37.943 24.361 39.273 20.199 39.273C12.486 39.273 6 33.15 6 25.636C6 18.121 12.486 12 20.2 12C24.466 12 27.506 13.631 29.79 15.758L27.092 18.387C25.454 16.89 23.235 15.726 20.195 15.726C14.563 15.726 10.157 20.149 10.157 25.636C10.157 31.124 14.563 35.547 20.195 35.547C23.849 35.547 25.929 34.117 27.262 32.819C28.343 31.766 29.055 30.261 29.335 28.206L20.195 28.21V28.21Z"
          fill="#4285F4"
        />
      </svg>
      <svg
        width="120"
        height="60"
        viewBox="0 0 120 60"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="flex-grow-0 flex-shrink-0 w-[120px] h-[60px]"
        preserveAspectRatio="none"
      >
        <path
          d="M17.0001 14L23.3923 16.2487V38.7494L32.396 33.5517L27.9817 31.4805L25.1968 24.5489L39.3833 29.5329V36.7788L23.3959 46L17 42.4423L17.0001 14Z"
          fill="#008373"
        />
        <path
          d="M48.9786 39.6049V20.3909H54.4454C56.1069 20.3909 57.4244 20.7974 58.3981 21.6103C59.3717 22.4231 59.8586 23.4817 59.8586 24.7858C59.8586 25.8755 59.5638 26.8225 58.9743 27.6264C58.3847 28.4303 57.5718 29.002 56.5356 29.3414V29.3949C57.8309 29.5467 58.867 30.0359 59.6442 30.8621C60.4213 31.6884 60.8099 32.7625 60.8099 34.0846C60.8099 35.7281 60.2203 37.0591 59.0412 38.0774C57.8621 39.0958 56.3749 39.6048 54.5794 39.6048L48.9786 39.6049ZM51.2297 22.4276V28.6313H53.5343C54.767 28.6313 55.7362 28.3342 56.4418 27.7402C57.1475 27.1462 57.5003 26.3088 57.5004 25.2279C57.5003 23.361 56.2721 22.4276 53.8157 22.4276H51.2297ZM51.2297 30.6545V37.5684H54.2846C55.6066 37.5684 56.6317 37.2558 57.3597 36.6304C58.0877 36.0052 58.4517 35.1477 58.4517 34.0579C58.4517 31.789 56.9064 30.6545 53.8157 30.6545H51.2297Z"
          fill="#008373"
        />
        <path
          d="M64.8012 22.8313C64.4081 22.8313 64.0732 22.6973 63.7962 22.4293C63.5193 22.1613 63.3809 21.8219 63.3809 21.411C63.3809 21.0001 63.5193 20.6584 63.7962 20.386C64.0732 20.1135 64.4081 19.9773 64.8012 19.9773C65.2031 19.9773 65.5448 20.1135 65.8262 20.386C66.1076 20.6584 66.2483 21.0001 66.2483 21.411C66.2483 21.8041 66.1076 22.139 65.8262 22.4159C65.5448 22.6928 65.2031 22.8313 64.8012 22.8313V22.8313ZM65.8731 39.6028H63.6757V25.987H65.8731V39.6028Z"
          fill="#008373"
        />
        <path
          d="M80.8027 39.6047H78.6052V31.8799C78.6052 28.9679 77.6242 27.5119 75.4983 27.5119C74.3996 27.5119 73.4907 27.925 72.7716 28.7513C72.0525 29.5776 71.693 30.6205 71.693 31.8799V39.6047H69.4956V25.9889H71.693V28.22H71.7466C72.7828 26.4871 74.2594 25.6628 76.1666 25.6628C77.6673 25.6628 78.8151 26.1475 79.6101 27.1166C80.4051 28.0858 80.8026 29.4861 80.8026 31.3173L80.8027 39.6047Z"
          fill="#008373"
        />
        <path
          d="M96.2019 38.4385C96.2019 43.4764 93.7901 45.9954 88.9664 45.9954C87.2692 45.9954 85.8701 45.6932 84.6017 45.0501L85.1782 43.166C85.1782 43.166 86.6677 44.1559 88.9397 44.1559C92.3162 44.1559 94.0045 42.3927 94.0045 38.8018V37.3163H93.9509C92.9057 39.0671 91.4338 39.9199 89.3346 39.9199C87.6285 39.9199 86.2551 39.4059 85.2145 38.1866C84.1738 36.9673 83.6535 35.3304 83.6535 33.2759C83.6535 30.9445 84.214 29.0909 85.335 27.7153C86.4561 26.3397 87.9903 25.6519 89.9376 25.6519C91.7866 25.6519 93.0576 26.3932 93.9509 27.8761H94.0045V25.9826H96.2019V38.4385ZM94.0045 33.3947V31.4807C94.0045 30.3909 93.636 29.4575 92.899 28.6803C92.1621 27.9031 91.308 27.5146 90.2093 27.5146C88.8516 27.5146 87.7886 28.0081 87.0204 28.9951C86.2522 29.9822 85.8681 31.3645 85.8681 33.1421C85.8681 34.6696 86.2365 35.7819 86.9735 36.6974C87.7104 37.6131 88.6863 38.0709 89.9012 38.0709C91.1338 38.0709 92.0728 37.6332 92.8454 36.7577C93.6181 35.8824 94.0045 34.7614 94.0045 33.3947Z"
          fill="#008373"
        />
      </svg>
      <svg
        width="120"
        height="60"
        viewBox="0 0 120 60"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="flex-grow-0 flex-shrink-0 w-[120px] h-[60px]"
        preserveAspectRatio="none"
      >
        <g clipPath="url(#clip0_5_19)">
          <path
            d="M12 22.5728H17.7709L21.1312 31.2016L24.5351 22.5728H30.154L21.6932 43H16.0387L18.3547 37.5871L12 22.5728Z"
            fill="#5F01D1"
          />
          <path
            d="M36.0074 22.2292C31.6714 22.2292 28.9304 26.1323 28.9304 30.0191C28.9304 34.3929 31.9356 37.8605 35.9251 37.8605C38.9011 37.8605 40.0232 36.0406 40.0232 36.0406V37.4583H45.0565V22.5728H40.0232V23.9261C40.0232 23.9261 38.7713 22.2292 36.0074 22.2292V22.2292ZM37.078 27.0128C39.0786 27.0128 40.111 28.6017 40.111 30.0354C40.111 31.5793 39.0049 33.0943 37.078 33.0943C35.4809 33.0943 34.0377 31.7843 34.0377 30.1011C34.0377 28.3942 35.1986 27.0128 37.078 27.0128Z"
            fill="#5F01D1"
          />
          <path
            d="M46.79 37.4582V16H52.0545V23.9776C52.0545 23.9776 53.3049 22.2311 55.9239 22.2311C59.1273 22.2311 61.0042 24.6268 61.0042 28.0501V37.4582H55.7782V29.3389C55.7782 28.1804 55.2284 27.0612 53.983 27.0612C52.7152 27.0612 52.0545 28.1973 52.0545 29.3389V37.4582H46.79Z"
            fill="#5F01D1"
          />
          <path
            d="M69.98 22.231C65.0146 22.231 62.0579 26.0207 62.0579 30.081C62.0579 34.7017 65.6378 37.8605 69.9988 37.8605C74.2257 37.8605 77.9245 34.845 77.9245 30.1585C77.9245 25.0306 74.0518 22.231 69.98 22.231V22.231ZM70.0274 27.0566C71.7814 27.0566 72.995 28.5229 72.995 30.0865C72.995 31.4201 71.8641 33.0651 70.0274 33.0651C68.3444 33.0651 67.0814 31.71 67.0814 30.0719C67.0814 28.4938 68.1315 27.0566 70.0274 27.0566V27.0566Z"
            fill="#5F01D1"
          />
          <path
            d="M86.6949 22.231C81.7295 22.231 78.7728 26.0207 78.7728 30.081C78.7728 34.7017 82.3526 37.8605 86.7137 37.8605C90.9406 37.8605 94.6393 34.845 94.6393 30.1585C94.6393 25.0306 90.7667 22.231 86.6949 22.231V22.231ZM86.7423 27.0566C88.4963 27.0566 89.7098 28.5229 89.7098 30.0865C89.7098 31.4201 88.579 33.0651 86.7423 33.0651C85.0593 33.0651 83.7963 31.71 83.7963 30.0719C83.7963 28.4938 84.8464 27.0566 86.7423 27.0566V27.0566Z"
            fill="#5F01D1"
          />
          <path
            d="M98.7934 37.7741C100.724 37.7741 102.289 36.2032 102.289 34.2654C102.289 32.3275 100.724 30.7566 98.7934 30.7566C96.8627 30.7566 95.2976 32.3275 95.2976 34.2654C95.2976 36.2032 96.8627 37.7741 98.7934 37.7741Z"
            fill="#5F01D1"
          />
          <path
            d="M103.438 29.4678H97.1445L102.73 16H109L103.438 29.4678Z"
            fill="#5F01D1"
          />
        </g>
        <defs>
          <clipPath id="clip0_5_19">
            <rect
              width="97"
              height="27"
              fill="white"
              transform="translate(12 16)"
            />
          </clipPath>
        </defs>
      </svg>
      <svg
        width="120"
        height="60"
        viewBox="0 0 120 60"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="flex-grow-0 flex-shrink-0 w-[120px] h-[60px]"
        preserveAspectRatio="none"
      >
        <g clipPath="url(#clip0_5_46)">
          <path
            d="M107.432 36.1065L103.533 42.617H98.8609L104.961 32.583L99.0927 23.3532H104.266L107.973 29.1746L111.293 23.3532H115.888L110.405 32.698L116.737 42.617H111.563L107.432 36.1065ZM86.738 31.2425H93.147V30.8598C93.147 28.4468 92.4519 26.5702 90.1741 26.5702C87.9735 26.5702 86.8537 28.1788 86.738 31.2425V31.2425ZM91.1779 43C85.3094 43 81.9891 39.7447 81.9891 33.0426C81.9891 27.2214 84.6531 22.9702 90.2512 22.9702C94.8459 22.9702 97.8185 25.4979 97.8185 32.2V34.6129H86.738C86.9311 37.8299 88.2051 39.4 91.564 39.4C93.8034 39.4 96.197 38.5575 97.6255 37.6001V41.315C96.2744 42.234 94.1123 43.0002 91.1779 43.0002V43ZM66.8159 33.1194C66.8159 37.4851 68.0516 39.4 70.5609 39.4C73.1477 39.4 74.4605 37.4469 74.4605 32.966C74.4605 28.5235 73.2252 26.5702 70.7538 26.5702C68.1285 26.5702 66.8159 28.5618 66.8159 33.1193V33.1194ZM62.0672 33.1193C62.0672 26.6852 65.1559 22.9702 69.5957 22.9702C71.6034 22.9702 73.3023 23.8895 74.4605 25.6128V16H79.0547V42.617H74.8081L74.5763 40.1279C73.3407 42.0044 71.5647 43 69.4027 43C65.0785 43 62.0672 39.4767 62.0672 33.1193V33.1193ZM48.1682 42.617H43.5736V23.3532H48.0523L48.1682 24.9618H48.3997C49.3264 24.0427 50.9478 23.0469 53.689 23.0469C57.434 23.0469 58.9783 24.732 58.9783 28.5618V42.617H54.3841V29.0213C54.3841 27.5661 53.6505 26.8767 52.0288 26.8767C50.3686 26.8767 49.0175 27.7575 48.1682 28.7917V42.617ZM35.2343 33.6171H34.5779C30.6397 33.6171 29.057 34.4214 29.057 36.6808C29.057 38.4045 30.022 39.5532 31.9525 39.5532C33.5739 39.5532 34.655 38.8638 35.2341 38.0214L35.2343 33.6171ZM39.8285 37.9064C39.8285 39.4767 39.9059 41.047 40.0603 42.617H35.5816C35.4273 42.234 35.2729 41.5831 35.2341 41.0853H35.0412C34.1531 42.0044 32.9947 42.8852 30.2923 42.8852C26.7403 42.8852 24.3467 40.7023 24.3467 36.796C24.3467 32.8893 27.4739 30.5916 34.5007 30.5916H35.2343V29.5191C35.2343 27.451 34.2304 26.6852 32.0298 26.6852C29.6745 26.6852 26.9721 27.6809 25.7365 28.6002V24.8087C27.1265 24.0043 29.5201 23.0469 32.5702 23.0469C37.435 23.0469 39.8285 24.8085 39.8285 29.4809V37.9064Z"
            fill="black"
          />
          <path
            d="M13.0343 42.617V39.9363C13.0343 36.298 12.6097 34.4982 11.1425 31.3576L4 16.0003H8.94175L15.0034 29.1363C16.7794 32.9664 17.5516 34.9576 17.5516 39.3619V42.6172L13.0343 42.617ZM15.93 28.8681L21.5669 16H26.3157L20.6015 28.8682L15.93 28.8681Z"
            fill="#FC3F1D"
          />
        </g>
        <defs>
          <clipPath id="clip0_5_46">
            <rect
              width="112.737"
              height="27"
              fill="white"
              transform="translate(4 16)"
            />
          </clipPath>
        </defs>
      </svg>
    </div>
  )
}

export default Page
